var map = {
	"./10s": 62144,
	"./10s.json": 62144,
	"./20s": 17141,
	"./20s.json": 17141,
	"./30s": 90594,
	"./30s.json": 90594,
	"./Blitz": 2149,
	"./Blitz.json": 2149,
	"./Bullet": 42338,
	"./Bullet.json": 42338,
	"./CaissaHello_animation.riv": 65287,
	"./CaissaSuccess_animation.riv": 98902,
	"./Calculation_Trainer/Calculation_Trainer": 5581,
	"./Calculation_Trainer/Calculation_Trainer.json": 5581,
	"./Challenge_a_friend.riv": 2976,
	"./Classical": 22099,
	"./Classical.json": 22099,
	"./Didnt_find_any_opponent.riv": 91394,
	"./Intuition_Trainer/Intuition_Trainer": 47981,
	"./Intuition_Trainer/Intuition_Trainer.json": 47981,
	"./Play_against_Caissa_Bot.riv": 2715,
	"./Play_random_opponent.riv": 52002,
	"./Practice_from_a_position.riv": 54138,
	"./Rapid": 41028,
	"./Rapid.json": 41028,
	"./Search": 33993,
	"./Search.json": 33993,
	"./Snail": 69511,
	"./Snail.json": 69511,
	"./Solve_Puzzles/Solve_Puzzles": 61465,
	"./Solve_Puzzles/Solve_Puzzles.json": 61465,
	"./Square_Trainer/Square_training": 10266,
	"./Square_Trainer/Square_training.json": 10266,
	"./Start_new_game/v1": 55754,
	"./Start_new_game/v1.json": 55754,
	"./Start_new_game/v2": 5243,
	"./Start_new_game/v2.json": 5243,
	"./caissa_animation.riv": 33393,
	"./challenge_animation.riv": 20564,
	"./challenge_wait": 28025,
	"./challenge_wait.json": 28025,
	"./chessboardLoader": 11241,
	"./chessboardLoader.json": 11241,
	"./chessboardLoader2": 20897,
	"./chessboardLoader2.json": 20897,
	"./circlechess_opponent_matching_animation.riv": 82281,
	"./didnt_respond.riv": 83799,
	"./error_boundary_animation": 33406,
	"./error_boundary_animation.json": 33406,
	"./error_page_404.lottie": 75469,
	"./mobileMenuIcon": 66270,
	"./mobileMenuIcon.json": 66270,
	"./rejected_your_challenge.riv": 58430,
	"./successCheck": 76551,
	"./successCheck.json": 76551,
	"./under_construction": 66384,
	"./under_construction.json": 66384
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 55625;